import { render } from "./ClientSettingsIntegration.vue?vue&type=template&id=cbe3f42c&scoped=true"
import script from "./ClientSettingsIntegration.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./ClientSettingsIntegration.vue?vue&type=script&charset=utf-8&lang=js"

import "./ClientSettingsIntegration.vue?vue&type=style&index=0&id=cbe3f42c&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cbe3f42c"]])

export default __exports__